export default __webpack_public_path__ + "static/media/ProductPageImage11.5e80a0e4.jpg";